import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["value", "className", "onChange", "size", "placeholder", "kind", "iconLeft", "iconRight", "isDisabled", "hasError", "isResizable", "onBlur", "onFocus", "isRequired"];
import React, { useState, useRef, useMemo, useCallback } from 'react';
import { Flex, FlexItem, Icon } from '../';
import getConfig from '../../js/settings';
import { appendHtmlClass, responsivePropType } from '../../js/util';
import withValidation from '../Form/validation';
import '../Input/_index.scss';
import './_index.scss';
var INPUT_SIZE = getConfig('INPUT_SIZE');
var INPUT_SIZE_DEFAULT = getConfig('INPUT_SIZE_DEFAULT');
var INPUT_SIZE_PREFIX = getConfig('INPUT_SIZE_PREFIX');
var INPUT_KIND = getConfig('INPUT_KIND');
var INPUT_KIND_DEFAULT = getConfig('INPUT_KIND_DEFAULT');
var INPUT_KIND_PREFIX = getConfig('INPUT_KIND_PREFIX');
var TEXTAREA_ROWS_DEFAULT = getConfig('TEXTAREA_ROWS_DEFAULT');
var TextareaMemo = /*#__PURE__*/React.memo(function Textarea(_ref) {
  var value = _ref.value,
    className = _ref.className,
    onChange = _ref.onChange,
    size = _ref.size,
    placeholder = _ref.placeholder,
    kind = _ref.kind,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    isDisabled = _ref.isDisabled,
    hasError = _ref.hasError,
    isResizable = _ref.isResizable,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    isRequired = _ref.isRequired,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var sizeConfig = INPUT_SIZE[size];
  var sizeConfigIcon = sizeConfig.icon;
  var inputElement = useRef(null);
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var onClick = useCallback(function (event) {
    return inputElement && inputElement.current && inputElement.current.focus();
  }, [inputElement]);
  var onInputFocus = useCallback(function (event) {
    if (!isFocused) setIsFocused(true);
    if (typeof onFocus === 'function') onFocus(event);
  }, [isFocused, setIsFocused, onFocus]);
  var onInputBlur = useCallback(function (event) {
    if (isFocused) setIsFocused(false);
    if (typeof onBlur === 'function') onBlur(event);
  }, [isFocused, setIsFocused, onBlur]);
  var onInputChange = useCallback(function (event) {
    typeof onChange === 'function' && onChange(event.target.value, event);
  }, [onChange]);
  var newClassName = useMemo(function () {
    var result = className;
    var sizeClass = "" + INPUT_SIZE_PREFIX + size;
    var kindClass = "" + INPUT_KIND_PREFIX + INPUT_KIND[kind];
    result = appendHtmlClass(result, 'textarea');
    result = appendHtmlClass(result, sizeClass);
    result = appendHtmlClass(result, kindClass);
    if (hasError) result = appendHtmlClass(result, 'error');
    if (isDisabled) result = appendHtmlClass(result, 'disabled');
    if (isFocused) result = appendHtmlClass(result, 'focus');
    if (isResizable) result = appendHtmlClass(result, 'resizable');
    return result;
  }, [className, size, kind, hasError, isDisabled, isFocused, isResizable]);
  var getIcon = useCallback(function (name, size, className) {
    if (className === void 0) {
      className = null;
    }
    return name && /*#__PURE__*/React.createElement(FlexItem, {
      className: className,
      span: "shrink"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: name,
      size: size,
      display: "iblock"
    }));
  }, []);
  var newLeftIcon = useMemo(function () {
    return getIcon(iconLeft, sizeConfigIcon, 'icon-left');
  }, [iconLeft, sizeConfigIcon, getIcon]);
  var newRightIcon = useMemo(function () {
    return getIcon(iconRight, sizeConfigIcon, 'icon-right');
  }, [iconRight, sizeConfigIcon, getIcon]);
  var disabled = useMemo(function () {
    return isDisabled ? {
      disabled: 'disabled'
    } : {};
  }, [isDisabled]);
  return /*#__PURE__*/React.createElement(Flex, {
    className: newClassName,
    onClick: onClick
  }, newLeftIcon, /*#__PURE__*/React.createElement(FlexItem, {
    span: "auto",
    alignY: "stretch"
  }, /*#__PURE__*/React.createElement("textarea", Object.assign({
    className: "input-target",
    value: value,
    placeholder: placeholder,
    onChange: onInputChange,
    onFocus: onInputFocus,
    onBlur: onInputBlur,
    ref: inputElement,
    required: isRequired
  }, disabled, rest))), newRightIcon);
});
TextareaMemo.defaultProps = {
  isResizable: false,
  isDisabled: false,
  hasError: false,
  size: INPUT_SIZE_DEFAULT,
  kind: INPUT_KIND_DEFAULT,
  rows: TEXTAREA_ROWS_DEFAULT,
  isRequired: false
};
export default withValidation(TextareaMemo);